import { MemberEligibilityInfo } from "@/App/types";
import "./MemberCard.scss";

interface Props {
  memberEligibilityInfo: MemberEligibilityInfo;
}

export const NonDiscountCardFront: React.FC<Props> = (props: Props) => {
  const { memberEligibilityInfo } = props;

  // plan group_number is a string of group_numbers split by commas
  let group_number = memberEligibilityInfo.plan.group_number;

  // order of precedence group > plan account > plan
  if (memberEligibilityInfo.group.group_number) {
    group_number = memberEligibilityInfo.group.group_number.split(",")[0];
  } else if (memberEligibilityInfo.plan_account.group_number) {
    group_number = memberEligibilityInfo.plan_account.group_number.split(",")[0];
  } else {
    group_number = group_number ? group_number.split(",")[0] : null;
  }

  return (
    <div className="cv2">
      <div className="member-id-card-container member-id-card-front">
        <div role="presentation" className="member-id-card-header">
          <div className="member-id-card-header-text">
            <div className="member-id-card-header-title">Prescription ID Card</div>
          </div>
        </div>
        <div className="member-id-card-info">
          <div className="member-id-card-info-container">
            <div className="member-id-card-info top">
              <div>
                <span className="member-id-card-info-label">Rx BIN:</span> {memberEligibilityInfo.plan.bin_number}
              </div>
              <div>
                <span className="member-id-card-info-label">Rx GRP:</span> {group_number}
              </div>
              <div>
                <span className="member-id-card-info-label">Rx PCN:</span> {memberEligibilityInfo.plan.processor_control_number}
              </div>
              <div>
                <span className="member-id-card-info-label">Issuer:</span> 9151014609
              </div>
            </div>
            <div className="member-id-card-info bottom">
              <div>
                <span className="member-id-card-info-label">Member ID:</span> {memberEligibilityInfo.member.external_member_id}
              </div>
              <div>
                <span className="member-id-card-info-label">Member:</span> {memberEligibilityInfo.member.first_name}{" "}
                {memberEligibilityInfo.member.last_name}
              </div>
            </div>
          </div>
        </div>
        <div className="member-id-card-footer"></div>
      </div>
    </div>
  );
};
